import { getters } from "@/constants/state";

export default {
  [getters.START_TIMES_GETTER]: (state) => state.startTimes,
};
